import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import settingsService from "./settingsService";

export const getSettings = createAsyncThunk(
  "settings/get",
  async (thunkAPI) => {
    try {
      return await settingsService.getSettings();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateSettings = createAsyncThunk(
  "settings/update",
  async (settingsData, thunkAPI) => {
    try {
      return await settingsService.updateSettings(settingsData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  settings: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.settings = action.payload.data;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      });
  },
});

export default settingsSlice.reducer;
